import { NavLink, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { CgProfile } from "react-icons/cg";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../../assets/logo.png";
import "./header.css";
import { useEffect, useState, useRef } from "react";
import { useSearchContext } from "../SearchContext";

import { API_BASE_URL } from "../api_config";

const Header = ({ file, name }) => {
  const navigate = useNavigate();
  const { clearSearchResults } = useSearchContext();
  const [isSticky, setIsSticky] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navRef = useRef(null);

  // Handle scroll event to make header sticky
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
  
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target) && mobileMenuOpen) {
        document.getElementById("close-btn").checked = true;
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileMenuOpen]);

  const handleLogout = () => {
    Cookies.remove("m_host-token");
    navigate("/signup", { replace: true });
  };

  const handleMenuToggle = (isOpen) => {
    setMobileMenuOpen(isOpen);
  };

  const handleNavigation = (path) => {
    
    if (!path.includes('/search') && !path.includes('/view-profile')) {
      clearSearchResults();
    }
    
    handleMenuToggle(false);
  };

  return (
    <nav className={`custom-navbar ${isSticky ? 'sticky' : ''}`} ref={navRef}>
      <div className="custom-wrapper">
        <NavLink to="/">
          <img src={logo} alt="logo" className="custom-logo" />
        </NavLink>
        <input 
          type="radio" 
          name="slider" 
          id="menu-btn" 
          onChange={() => handleMenuToggle(true)}
        />
        <input 
          type="radio" 
          name="slider" 
          id="close-btn" 
          onChange={() => handleMenuToggle(false)}
        />
        <ul className="custom-nav-links">
          <label htmlFor="close-btn" className="custom-btn custom-close-btn">
            <FaTimes />
          </label>
          <li>
            <NavLink to="/" onClick={() => handleNavigation('/')}>Home</NavLink>
          </li>
          <li>
            <NavLink to="/searchBox" onClick={() => handleNavigation('/searchBox')}>Search</NavLink>
          </li>
          {/* <li>
            <NavLink className="custom-desktop-item">Matches</NavLink>
            <input type="checkbox" id="showDropMatches" />
            <label htmlFor="showDropMatches" className="custom-mobile-item">
              Matches
            </label>
            <ul className="custom-drop-menu">
              <li>
                <NavLink to="/matches/daily-recommendations" onClick={() => handleMenuToggle(false)}>
                  Daily Recommendations
                </NavLink>
              </li>
              <li>
                <NavLink to="/matches/total-matches" onClick={() => handleMenuToggle(false)}>Total Matches</NavLink>
              </li>
              <li>
                <NavLink to="/matches/partner-preferences" onClick={() => handleMenuToggle(false)}>
                  Partner Preference
                </NavLink>
              </li>
            </ul>
          </li> */}
          <li>
            <NavLink to="/mailbox" onClick={() => handleNavigation('/mailbox')}>Mailbox</NavLink>
          </li>
          <li>
            <NavLink to="/payment/paymentoption" onClick={() => handleNavigation('/payment/paymentoption')}>Upgrade Now</NavLink>
          </li>
          <li>
            <NavLink  className="custom-desktop-item" id="bg-prof-hov">
              {file === null || file === undefined ? (
                <CgProfile size={30} />
              ) : (
                <img
                  src={`${API_BASE_URL}/uploads/` + file}
                  alt={`${name}`}
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    objectPosition: "top",
                    borderRadius: "50%",
                  }}
                />
              )}
            </NavLink>
           

            <label htmlFor="showDropProf" className="custom-mobile-item">
              {file === null || file === undefined ? (
                <CgProfile size={24} />
              ) : (
                <img
                  src={`${API_BASE_URL}/uploads/` + file}
                  alt={`${name}`}
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "cover",
                    objectPosition: "top",
                    borderRadius: "50%",
                    marginRight: "10px"
                  }}
                />
              )}
              <span>My Profile</span>
            </label>
             <input type="checkbox" id="showDropProf" />
            <ul className="custom-drop-menu-prof">
              <li>
                <NavLink to="/edit-profile" onClick={() => handleNavigation('/edit-profile')}>Edit Profile</NavLink>
              </li>
              <li>
                <NavLink to="/edit-partner-preferences" onClick={() => handleNavigation('/edit-partner-preferences')}>
                  Edit Partner
                </NavLink>
              </li>
              <li>
                <NavLink to="/horoscope" onClick={() => handleNavigation('/horoscope')}>Horoscope</NavLink>
              </li>
              <li>
                <NavLink to="/Mailbox" onClick={() => handleNavigation('/Mailbox')}>Mailbox</NavLink>
              </li>
              <li>
                <button
                  type="button"
                  className="logout-btn"
                  onClick={() => {
                    handleLogout();
                    handleMenuToggle(false);
                  }}>
                  Logout
                </button>
              </li>
            </ul>
          </li>
        </ul>
        <label htmlFor="menu-btn" className="custom-btn custom-menu-btn">
          <FaBars />
        </label>
      </div>
    </nav>
  );
};

export default Header;
